const STATE_NAME = {
  backToMerchant: 'back_to_merchant',
  billing: 'billing',
  fallbackHermes: 'redirect_hermes',
  fallbackXoon: 'redirect_xoon',
  init: 'XO_SIGNUP_LITE_INIT',
  signup: 'signup',
};

const TRANSITION_NAME = {
  backToMerchant: 'prepare_back_to_merchant',
  cancelAndRtm: 'prepare_cancel_and_back_to_merchant',
  fallbackHermes: 'process_redirect_hermes',
  fallbackXoon: 'process_redirect_xoon',
  interactive: 'prepare_billing_page_interactive',
  isAddressless: 'prepare_address_fields',
  login: 'prepare_login',
  pageLoaded: 'prepare_billing_page_loaded',
  prepareBilling: 'prepare_billing_page',
  render: 'prepare_billing',
  renderThreeDS: 'prepare_threeDS_page',
  submitPayment: 'process_billing',
};

// Logged for every event, is merged with payload param in fpti function
const COMMON_PAYLOAD = {
  buyer_type: 'NewUser',
  comp: 'checkoutuinodeweb',
  context_id: null,
  context_type: 'EC-token',
  design: 'full context',
  enrich: 'n',
  experience: 'signuplite',
  feed_name: 'checkoutuinodeweb',
  host_name: window.location.hostname,
  serverside_data_source: 'checkout',
  'x-paypal-fpti': 'TBD',
};

const ACCOUNT_CREATION_PAYLOAD = data => {
  const { buyerId, cartAmount, locale, merchantId } = data;
  return {
    amt: cartAmount.currencyValue,
    ccpg: locale.country,
    comp: 'checkoutuinodeweb',
    curr: cartAmount.currencyCode,
    cust: buyerId,
    mrid: merchantId,
    page: 'main:xo:lite:weasley:guestAndSignup:billing',
    pgrp: 'main:xo:lite',
  };
};

const INPUT_FIELD_ERROR_STATUS_PAYLOAD = (fieldName, isValid, errorCode) => ({
  int_error_code: isValid ? '0' : '1',
  int_error_desc: isValid ? '' : errorCode,
  state_name: STATE_NAME.billing,
  transition_name: `process_${fieldName}_field_error_status`,
});

const ERROR_PAYLOAD = ({ code, desc, source }) => ({
  error_source: source,
  int_error_code: code,
  int_error_desc: desc,
});

const INTERSTITIAL_PAYLOAD = ({ action, name, stateName }) => ({
  state_name: stateName || STATE_NAME.signup,
  transition_name: `prepare_${name}_interstitial_${action}`,
});

const IS_ADDRESSLESS_PAYLOAD = isAddressless => ({
  is_addr_shown: isAddressless ? 0 : 1,
  state_name: STATE_NAME.signup,
  transition_name: TRANSITION_NAME.isAddressless,
});

const DEFAULT_TAB_FIELD_INDEX = tabName => ({
  default_tab_index: tabName,
  state_name: STATE_NAME.signup,
  transition_name: `prepare_${tabName}_tab_on_load`,
});

const LOG_IN_PAYLOAD = () => ({
  state_name: STATE_NAME.signup,
  transition_name: TRANSITION_NAME.login,
});

const ONBOARD_OPTION_CHANGED_PAYLOAD = accountType => ({
  account_signup_type: accountType,
  state_name: 'billing',
  transition_name: 'process_account_type_selection',
});

const ONBOARD_SUCCESS_PAYLOAD = ({ mode = 'signup', startTime }) => ({
  event_time: Date.now() - startTime,
  state_name: STATE_NAME[mode],
  transition_name: `process_${mode}_checkout_success`,
});

const PAGE_LOAD_PAYLOAD = (isLoaded = false) => {
  const transition = isLoaded ? 'pageLoaded' : 'interactive';

  return {
    page_load_time: window.performance?.now(),
    state_name: STATE_NAME.billing,
    transition_name: TRANSITION_NAME[transition],
  };
};

const PREPARE_BILLING_PAYLOAD = isGuestEligible => ({
  forced_signup_offered: isGuestEligible ? 0 : 1,
  pay_upon_invoice: 'N',
  ship_to_billing: 'Y',
  state_name: STATE_NAME.billing,
  transition_name: TRANSITION_NAME.prepareBilling,
});

const SIGNUP_PAYLOAD = ({ action } = {}) => ({
  state_name: STATE_NAME.signup,
  transition_name: TRANSITION_NAME[action],
});

const TRANSACTION_DETAILS_PAYLOAD = checkoutSession => {
  const {
    cart: { amounts },
    merchant: { merchantId },
  } = checkoutSession;
  const { currencyCode = '', currencyValue } = amounts?.total;

  return {
    // Amount in cents
    amt: parseFloat(currencyValue || 0) * 100,
    currency_code: currencyCode,
    seller_id: merchantId,
  };
};

const TRACK_FIELD_INPUT_PAYLOAD = ({ charCount, fieldName, fieldType }) => ({
  char_cnt: charCount,
  field_name: fieldName,
  field_type: fieldType,
  state_name: 'form_fill',
  transition_name: 'field_fill',
});

export {
  ACCOUNT_CREATION_PAYLOAD,
  COMMON_PAYLOAD,
  ERROR_PAYLOAD,
  INPUT_FIELD_ERROR_STATUS_PAYLOAD,
  INTERSTITIAL_PAYLOAD,
  IS_ADDRESSLESS_PAYLOAD,
  DEFAULT_TAB_FIELD_INDEX,
  LOG_IN_PAYLOAD,
  ONBOARD_OPTION_CHANGED_PAYLOAD,
  ONBOARD_SUCCESS_PAYLOAD,
  PAGE_LOAD_PAYLOAD,
  PREPARE_BILLING_PAYLOAD,
  SIGNUP_PAYLOAD,
  STATE_NAME,
  TRACK_FIELD_INPUT_PAYLOAD,
  TRANSACTION_DETAILS_PAYLOAD,
  TRANSITION_NAME,
};
